import { useState, useEffect } from "react";
import TextBox from '@/frontend/components/qecomps/TextBox';
import WindowFloat from '@/frontend/components/qecomps/WindowFloat';
import ExpTitle from '../journal/ExpTitle';
import Cap from '@/frontend/components/qecomps/Cap';

import Component, { PageEl } from '@/frontend/components/qecomps/Component'
import Img from "../qecomps/Img";
export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {
    getProps(async () => {
        props.inited = false
        props.items = []
        props.loading = true
    })
    let text = ""
    useEffect(() => {
        global.setScroller("expassign")
        if (props.items.length == 0 && !props.inited) {
            ; (async () => {

                let json = await API['explore/get']({
                    text: null,
                    query: props.query || {},
                    lang: z.lang.code,
                })

                if (json.code == 0) {
                    refresh({ inited: true, items: json.items, loading: false })
                }
            })();
        }
    })
    return <WindowFloat title={Cap(z.lang.expassign)} onclose={() => { global.setScroller("wind"); props.onclose?.() }}>
        <TextBox title={z.lang.stitle} righticon=
            {<Img src={global.cdn("/files/go.svg")}
                className={z.styles.hover}
                style={{
                    width: 30, height: 30,
                    transform: z.lang.dir == "rtl" ? "rotate(180deg)" : null, margin: "0 5px"
                }} />}
            defaultValue={text}
            on={(txt) => {
                text = txt
            }}

            onenter={async () => {
                refresh({ items: [], loading: true })

                let json = await API['explore/get']({
                    text,
                    query: props.query || {},
                    lang: z.lang.code,
                })

                if (json.code == 0) {
                    refresh({ inited: true, items: json.items, loading: false })
                }
            }} />
        <br-xx />
        <div id="expassign" style={{
            overflowY: "auto",
            height: 350, maxHeight: 350, width: "100%",
        }}>

            <f-cc>{props.loading ? <Img src={global.cdn("/files/loadingcirc.svg")} style={{ height: 60, width: 60 }} /> : null}</f-cc>
            {props.items.length > 0 ? <hr /> : null}
            {props.noexplore && text.length == 0 ? <>
                <ExpTitle item={{
                    icon: global.cdn("/files/globe.svg"),
                    title1: z.lang.noexp,
                    title2: z.lang.noexp2,
                }} on={() => {
                    props.on?.(null)
                }} />
            </> : null}

            {props.items.map(it => {
                return <>
                    <ExpTitle key={"it_" + it.expid} item={{
                        icon: it.icon || global.cdn("/files/logocircular.webp"),
                        title1: it.title1 || "Unknown", title2: it.title2 || "Unknown"
                    }} on={() => {
                        props.on?.(it)
                    }} />
                    <hr /></>
            })}
        </div>
        <br-x />
    </WindowFloat>
}